import React from 'react';
import i18n from 'i18next';

import OrderConfirmation from './order-confirmation';

const { UI, Order } = Mobi2Go;

Order.onReady(() => {
    const modal = UI.ExternalModal.create(
        'confirmation',
        <OrderConfirmation
            order={Order}
            closeModal={() => modal.close()}
            openModal={() => modal.open()}
            isModalOpen={() => modal.isOpen()}
            scrollToBottomOfModal={() => modal.scrollToBottom()}
            setModalIsClosable={is_closable => modal.setIsClosable(is_closable)}
            setModalAttribute={(key, value) =>
                modal.container.setAttribute(key, value)
            }
            removeModalAttribute={key => modal.container.removeAttribute(key)}
        />,
        {
            'data-view': 'confirmation',
            className: 'm2g-order-confirmation m2g-order-confirmation--v2',
        }
    );

    modal.container.classList.add('m2g-order-state');
    modal.container.classList.add('m2g-order-confirmation');

    modal.container.setAttribute('data-phase', 'unconfirmed');
    modal.container.setAttribute('data-status', 'confirmable');

    modal.mount();

    UI.bind({
        showConfirmation: () => {
            if (!Order.isConfirmable()) {
                return;
            }

            modal.open();

            Order.invalidateTimeSlots();
            Order.save(function() {
                if (!Order.isConfirmable()) {
                    modal.close();
                    UI.trigger('progressPrompt');
                }
            });
        },
        hideConfirmation: () => {
            modal.close();
        },
        show3DSRedirectionPrompt: url => {
            /**
             * Triggered when a direct payment is submitted and requires a redirection
             * to an external page to pass 3D secure validation.
             *
             * Prompts the user to follow redirection or cancel payment.
             */
            UI.centeredAlert({
                id: '3ds-redirection-prompt',
                title: i18n.t('order.confirmation:3ds_redirection_prompt_text'),
                body: i18n.t(
                    'order.confirmation:3ds_redirection_prompt_subtext'
                ),
                primary_button: i18n.t(
                    'order.confirmation:3ds_redirection_prompt_primary_button'
                ),
                onPrimaryButtonClick: () => {
                    window.location = url;
                },
                secondary_button: i18n.t(
                    'order.confirmation:3ds_redirection_prompt_secondary_button'
                ),
                onSecondaryButtonClick: () => {
                    Order.cancelConfirmation();
                },
            });
        },
    });
});
